import { render, staticRenderFns } from "./ncs.vue?vue&type=template&id=24b52dd8&"
import script from "./ncs.vue?vue&type=script&lang=js&"
export * from "./ncs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports